import axios from 'axios'

const token = "Bearer yuiFbyemq8tYxUoBKo2_plELGG3eB9cNqF6DkGC8n67LC6mwOe7ynhI+QtqKuvGJlZY";

const instance = axios.create({
  // baseURL: 'https://dev.bibomart.net/products_biboshop'
   baseURL: 'https://prod.bibomart.net/products_biboshop'
});

instance.interceptors.request.use(function (config) {
    config.headers.Authorization =  token;
    return config;
});

instance.interceptors.response.use((response) => {
    return response.data
}, error => {
  return Promise.resolve({ error });
  // window.localStorage.setItem('errornetwworkmsg', error);
  // return window.location.href = '/404.html';
})

export default instance;